export default __webpack_public_path__ + "static/media/DPD.bd1b0178.pdf";